import api from 'api/apiInstance';

export function userDeactivateApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
